import { render, staticRenderFns } from "./OrgQuotaDrawer.vue?vue&type=template&id=f0e1465e&scoped=true"
import script from "./OrgQuotaDrawer.vue?vue&type=script&lang=js"
export * from "./OrgQuotaDrawer.vue?vue&type=script&lang=js"
import style0 from "./OrgQuotaDrawer.vue?vue&type=style&index=0&id=f0e1465e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e1465e",
  null
  
)

export default component.exports